import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Option } from '../types/option';
import axios from 'axios';
import { useDispatch } from 'react-redux';
export const SsoLogin = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        const login = async () => {
            const token = Option.some(new URLSearchParams(window.location.search).get('token'));

            await token.match(
                async () => navigate('/login'),
                async v => {
                    try {
                        const response = await axios.post('/token', { token: v });

                        if (response.status !== 200) {
                            navigate('/login');
                            return;
                        }

                        localStorage.setItem('bearer', response.data.token);
                        localStorage.setItem('sso', 'true');
                        navigate('/dashboard_agency');
                    } catch (error) {
                        console.error(error);
                        navigate('/login');
                    }
                },
            );
        };

        void login();
    }, [dispatch, navigate]);

    return <div>Chargement...</div>;
};
